import client from './client';

export const paymentsApi = {
  createCheckoutSession(data) {
    return client.post('/payments/create-checkout-session', data);
  },
  getByPackage(packageId) {
    return client.get(`/payments/package/${packageId}`);
  },
  syncByPackage(packageId) {
    return client.post(`/payments/package/${packageId}/sync`);
  },
  createRefund(paymentId, data) {
    return client.post(`/payments/${paymentId}/refund`, data);
  },
  getRefunds(paymentId) {
    return client.get(`/payments/${paymentId}/refunds`);
  },
  getStats(params = {}) {
    return client.get('/payments/stats', { params });
  },
  getStatsByStatus(params = {}) {
    return client.get('/payments/stats/by-status', { params });
  },
  getStatsByPeriod(params = {}) {
    return client.get('/payments/stats/by-period', { params });
  },
  getEscrowPending() {
    return client.get('/payments/escrow/pending');
  },
  releaseEscrow(paymentId) {
    return client.post(`/payments/escrow/${paymentId}/release`);
  },
};

